export default __webpack_public_path__ + "static/media/heart-icon.1d86de98.svg";